import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EasyDgdService, PreviewImageViewModel } from '@hazmatsuite-next/easydgd-lib';
import { LicenseDependentButtonModel, LanguageService, PaymentType, ActionType, TransportMode, LicenseService } from '@hazmatsuite-next/ui';
import { Store } from '@ngrx/store';
import { Observable, map, switchMap, take, tap } from 'rxjs';
import { EasyDgdDataState } from '../../store/easydgd-data.reducer';
import { selectStepState } from '../../store/easydgd-data.selectors';

@Component({
  selector: 'easydgd-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviewComponent {
  public stepperItems$ = this.easyDgdStore.select(selectStepState);

  layoutResource$ = this.languageService.translations$.pipe(
    map(data => data['LayoutResource'])
  );
  downloadResource$ = this.languageService.translations$.pipe(
    map(data => data['DownloadResource'])
  );
  easyDgdCommonResource$ = this.languageService.translations$.pipe(
    map(data => data['EasyDgdCommonResource'])
  );

  form = new FormGroup({});
  skipPreview = false;

  licenseDependentButtonModel: LicenseDependentButtonModel = {
    IsHeroButton: false,
    ActionType: this.getActionType(),
    IsPaymentDetailView: true,
    ButtonAlignmentRight: false,
    OpenInNewTab: false,
    ContactText: '',
    AdditionalButtonCss: '',
    Toolname: 'EasyDgd',
    ShowCreditsModal: true,
    ButtonIcon: '',
    FullWidth: false,
  }

  previewResult$: Observable<PreviewImageViewModel | void> = this.licenseService.checkLicense(this.licenseDependentButtonModel, true)
    .pipe(
      take(1),
      switchMap(res => {
        this.skipPreview = res.UserHasSubscription;
        if (this.skipPreview) {
          return this.licenseService.savePaymentSummary({
            InformationTitle: '',
            InformationText: '',
            LicenseDependentButtonModel: this.licenseDependentButtonModel
          }).pipe(
            take(1),
            tap(() => {
              this.buyDocument(PaymentType.Subscription);
            })
          );
        } else {
          return this.easydgdService.loadPreview();
        }
      }));

  constructor(
    private activatedRoute: ActivatedRoute,
    private easydgdService: EasyDgdService,
    private languageService: LanguageService,
    private licenseService: LicenseService,
    private easyDgdStore: Store<{ easyDgdState: EasyDgdDataState }>) {

  }

  selectStep(index: number): void {
    // this.easydgdService.activateStep(index, this.activatedRoute);
  }

  enableStepHistory(): void {
    // this.easydgdService.enableStepHistory().pipe(take(1)).subscribe();
  }

  buyDocument(paymentType: PaymentType): void {
    this.easydgdService
    this.easydgdService.setPaymentType(paymentType).pipe(take(1)).subscribe(() => {
      // this.easydgdService.activateNextStep(this.activatedRoute);
    });
  }

  private getActionType(): ActionType {
    const transportMode = this.easydgdService.getTransportMode();
    switch (transportMode) {
      case TransportMode.Road:
        return ActionType.EasyDgdAdrDocument;
      case TransportMode.Rail:
        return ActionType.EasyDgdRidDocument;
      case TransportMode.Sea:
        return ActionType.EasyDgdImoDocument;
      case TransportMode.Air:
        return ActionType.EasyDgdAirDocument;
    }

    return ActionType.Undefined;
  }
}
